<template>
    <v-form-element v-bind="$props">
        <label :id="labelId" class="relative z-20 flex items-center justify-center w-full px-12 py-6 bg-white hover:bg-white border border-gray-300 border-dashed hover:border-primary focus:border-primary-dark rounded text-lg text-gray-500 text-center cursor-pointer transition-all duration-300">
            <i class="cursor-pointer fas fa-cloud-upload-alt opacity-50 text-[20px] mr-2"></i>
            <span class="cursor-pointer" v-if="files.length > 0">{{ $tc('form.labels.file_uploader_button_selected_multiple', count, {count: files.length}) }}</span>
            <span class="cursor-pointer" v-if="file">{{ $t('form.labels.file_uploader_button_selected') }}</span>
            <template v-if="! file && files.length == 0">
                <span class="cursor-pointer" v-if="multiple">{{ $t('form.labels.file_uploader_button_multiple') }}</span>
                <span class="cursor-pointer" v-else>{{ $t('form.labels.file_uploader_button') }}</span>
            </template>
            <input :id="inputId" type="file" class="absolute z-10 pin block w-full opacity-0" :placeholder="getPlaceholder()" :required="required" ref="file" @change="handleFileUpload" :multiple="multiple" />
        </label>
    </v-form-element>
</template>

<script>

    import FormElement from './Element';
    import mixin from './mixin';

    export default {
        data() {
            return {
                labelId: null,
                inputId: null,
                files: [],
                file: null
            }
        },
        components: {
            'v-form-element': FormElement
        },
        mixins: [mixin],
        props: {
            multiple: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            handleFileUpload()
            {
                if ( this.multiple ) {
                    this.files = this.$refs.file.files;
                    return;
                }

                this.file = this.$refs.file.files[0];
            }
        },
        created() {
            this.labelId = this.randomId();
            this.inputId = this.randomId();
        },
        mounted() {
            let label = document.getElementById(this.labelId);
            let input = document.getElementById(this.inputId);
            let vue = this;
            document.addEventListener('dragenter', function (event) {
                if ( event.toElement && event.toElement.id == vue.inputId ) {
                    label.classList.add('shadow-md');
                    label.classList.add('bg-white');
                    label.classList.remove('bg-gray-100');
                }
            }, false);
            document.addEventListener('drop', function (event) {
                if ( event.toElement && event.toElement.id == vue.inputId ) {
                    label.classList.remove('shadow-md');
                    label.classList.remove('bg-white');
                    label.classList.add('bg-gray-100');
                }
            }, false);
            document.addEventListener('dragexit', function (event) {
                if ( event.toElement && event.toElement.id == vue.inputId ) {
                    label.classList.remove('shadow-md');
                    label.classList.remove('bg-white');
                    label.classList.add('bg-gray-100');
                }
            }, false);
            document.addEventListener('dragleave', function (event) {
                if ( event.toElement && event.toElement.id == vue.inputId ) {
                    label.classList.remove('shadow-md');
                    label.classList.remove('bg-white');
                    label.classList.add('bg-gray-100');
                }
            }, false);
            document.addEventListener('dragend', function (event) {
                if ( event.toElement && event.toElement.id == vue.inputId ) {
                    label.classList.remove('shadow-md');
                    label.classList.remove('bg-white');
                    label.classList.add('bg-gray-100');
                }
            }, false);
        }
    }
</script>
